/* eslint-disable */
import CharaBase from "../../common/CharaBase";
import Helper from "../../common/Helper";

class CharaPlayer extends CharaBase {
  constructor(scene) {
    super(scene);

    this.result = true;
    this.resultFailRotationSpeed = Math.floor(Math.random() * 10) / 100;
  }

  //------------------------------------
  // Setup Mesh
  //------------------------------------
  setupMeshs() {
    //Human Setup
    this.human = this.scene.getNodeByID("Human");
    this.scene.getNodeByID("Human_Bag").parent = this.human;
    this.scene.getNodeByID("Human_Bag_Fire_L").parent = this.human;
    this.scene.getNodeByID("Human_Bag_Fire_R").parent = this.human;
    this.scene.getNodeByID("Human_Bag_Nozzle_L").parent = this.human;
    this.scene.getNodeByID("Human_Bag_Nozzle_R").parent = this.human;

    this.setAnimationGroup(
      this.scene.animationGroups[0].name,
      this.scene.animationGroups[0]
    );
    this.setAnimationGroup(
      this.scene.animationGroups[1].name,
      this.scene.animationGroups[1]
    );
    this.setAnimationGroup(
      this.scene.animationGroups[2].name,
      this.scene.animationGroups[2]
    );
    this.setAnimationGroup(
      this.scene.animationGroups[3].name,
      this.scene.animationGroups[3]
    );

    this.startAnimation("Waiting", true);

    //Pod Setup
    this.pod = this.scene.getNodeByID("Pod_root");

    //Rocket Setup
    this.rocket = this.scene.getNodeByID("Rocket_root");

    //Physics Setup
    this.physic = new BABYLON.MeshBuilder.CreateSphere("player", {
      diameter: 0.1
    });

    this.physic.position.y = 0;
    this.physic.visibility = 0;

    this.physic.physicsImpostor = new BABYLON.PhysicsImpostor(
      this.physic,
      BABYLON.PhysicsImpostor.SphereImpostor,
      { mass: 1, restitution: 0.9 },
      this.scene
    );
  }

  //------------------------------------
  // Setting
  //------------------------------------
  changeMember(member) {
    this.human.setEnabled(false);

    for (var i = 0; i < this.human.getChildren().length; i++) {
      this.human.getChildren()[i].setEnabled(false);
    }

    this.pod.setEnabled(false);
    this.rocket.setEnabled(false);

    switch (member) {
      case 0:
        this.mesh = this.human;
        break;
      case 1:
        this.mesh = this.pod;
        break;
      case 2:
        this.mesh = this.rocket;
        break;
    }

    this.mesh.setEnabled(true);

    for (var i = 0; i < this.mesh.getChildren().length; i++) {
      this.human.getChildren()[i].setEnabled(true);
    }

    this.mesh.position.x += this.resultFailRotationSpeed;
    this.mesh.position.y += this.resultFailRotationSpeed;
    this.mesh.position.z += this.resultFailRotationSpeed;
  }

  //------------------------------------
  // Update
  //------------------------------------
  update() {
    this.mesh.position = this.physic.getAbsolutePosition();

    if (!this.result) {
      this.theta += 0.05;
      this.mesh.rotationQuaternion = new BABYLON.Quaternion.RotationAxis(
        new BABYLON.Vector3(1, 1, 1),
        this.theta
      );
    }
  }

  //------------------------------------
  // Play
  //------------------------------------
  boost(result, power, distance) {
    this.result = result;

    this.theta = 0;

    let x = 0;
    let impulse = Helper.getPlanetPosition(distance);

    switch (distance) {
      case 0:
        impulse = impulse / 2;
        break;
      case 1:
        impulse = impulse / 3.25;
        break;
      case 2:
        impulse = impulse / 3.5;
        break;
      case 3:
        impulse = impulse / 6;
        break;
      case 4:
        impulse = impulse / 7;
        break;
    }

    //Failの場合は変な飛ばし方をする
    if (!this.result) {
      impulse = impulse * power;
      x = Math.random() * 60 - 30;
    }

    impulse = Math.floor(impulse * 100) / 100;

    //Impluse！
    this.physic.physicsImpostor.applyImpulse(
      new BABYLON.Vector3(x, impulse, 0),
      this.physic.getAbsolutePosition()
    );

    this.update();
  }

  resetPosition() {
    this.result = true;

    this.physic.physicsImpostor.setAngularVelocity(
      new BABYLON.Vector3(0, 0, 0)
    );
    this.physic.physicsImpostor.setLinearVelocity(new BABYLON.Vector3(0, 0, 0));

    this.physic.position.copyFrom(new BABYLON.Vector3(0, 0, 0));
    this.physic.rotationQuaternion.copyFrom(new BABYLON.Quaternion(0, 0, 0, 0));
    this.mesh.position.copyFrom(new BABYLON.Vector3(0, 0, 0));
    this.mesh.rotationQuaternion.copyFrom(new BABYLON.Quaternion(0, 0, 0, 0));

    this.update();
  }

  getPosition() {
    return this.mesh.position;
  }
}
export default CharaPlayer;

//    this.physic.material = new BABYLON.StandardMaterial("player", this.scene);
//    this.physic.material.alpha = 0;
